import CantileverButton from 'components/CantileverButton'
import { DataLayer } from 'features/systemLens'
import { Sliders } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

import { DataLayersControl } from './DataLayersControl'

const ConfigureThresholdsButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
`

interface ChartControlsProps {
  dataLayers: DataLayer[]
  onToggleLayer: (layerId: string) => void
  operationalEventsCount: number
  handleConfigureThresholds: () => void
}

export const ChartControls: React.FC<ChartControlsProps> = ({
  dataLayers,
  onToggleLayer,
  operationalEventsCount,
  handleConfigureThresholds,
}) => {
  return (
    <>
      <DataLayersControl
        dataLayers={dataLayers}
        onToggleLayer={onToggleLayer}
        operationalEventsCount={operationalEventsCount}
      />
      {dataLayers.find((l) => l.id === 'thresholds')?.enabled && (
        <ConfigureThresholdsButtonContainer>
          <CantileverButton onClick={handleConfigureThresholds}>
            Configure Thresholds
            <Sliders size={16} />
          </CantileverButton>
        </ConfigureThresholdsButtonContainer>
      )}
    </>
  )
}
